export default __webpack_public_path__ + "static/media/95_mobile.7b85848d.jpg";